import { render, staticRenderFns } from "./MatchEditModal.vue?vue&type=template&id=68cea7d2&"
import script from "./MatchEditModal.vue?vue&type=script&lang=js&"
export * from "./MatchEditModal.vue?vue&type=script&lang=js&"
import style0 from "./MatchEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports